// extracted by mini-css-extract-plugin
export default {"logo":"laser_logo__n5lt4","fadeinout":"laser_fadeinout__zT9cu"};